<div class="d-flex align-items-center">
<ul ngbNav #nav="ngbNav" class="nav-tabs flex-grow-1" [destroyOnHide]="false" (navChange)="onNavChange($event)" [activeId]="activeId">
	<!-- Kein SEA-Punkt: eigene Reiter statt der SEA-Reiter. Ein solcher Punkt darf die
	     SEA-Masken nie zeigen, sonst schriebe jemand SEA-Angaben in eine fremde Aufnahme. -->
	@if (!istSeaPunkt()) {
		@if (verfahrenUnbekannt()) {
			<!-- Ein Verfahren, das diese Fassung nicht kennt: EIN Reiter mit dem Hinweis.
			     Vier Reiter mit Feldern wären dort eine Behauptung ueber den Aufbau. -->
			<li [ngbNavItem]="unbekanntReiter">
				<a ngbNavLink>{{ unbekanntReiter }}</a>
				<ng-template ngbNavContent>
					<bp-ka-uebersicht [bp]="bp"></bp-ka-uebersicht>
				</ng-template>
			</li>
		} @else {
			<!-- Je Block des amtlichen Bogens ein Reiter, gleich benannt wie die Maske,
			     die beim Antippen aufgeht (Nutzer-Entscheidung 20.09.2026). -->
			@for (r of kaReiter; track r.id) {
				<li [ngbNavItem]="r.titel">
					<a ngbNavLink>{{ r.titel }}</a>
					<ng-template ngbNavContent>
						<bp-ka-uebersicht [bp]="bp" [maske]="r.id"></bp-ka-uebersicht>
					</ng-template>
				</li>
			}
			<!-- Die Vegetationsaufnahme wird auch bei einer KA-Aufnahme angeboten
			     (Nutzer-Entscheidung 20.09.2026); ihre forstlichen Teile bleiben dort weg. -->
			<li ngbNavItem="Vegetation">
				<a ngbNavLink>Vegetation</a>
				<ng-template ngbNavContent>
					<bp-bohrpunkt-vegetation [bp]="bp"></bp-bohrpunkt-vegetation>
				</ng-template>
			</li>
		}
	}
	@else if (istPunktartMitProtokoll(bp.type)) {
		<li ngbNavItem="Allgemein">
			<a ngbNavLink>Allgemein</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-allgemein [bp]="bp"></bp-bohrpunkt-allgemein>
			</ng-template>
		</li>
		<li ngbNavItem="Boden">
			<a ngbNavLink>Boden</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-boden [bp]="bp"></bp-bohrpunkt-boden>
			</ng-template>
		</li>
		<!-- Direkt nach „Boden": Das Bild entsteht aus genau den Zeilen, die dort
		     erfasst werden, und man springt beim Erfassen hin und her. -->
		<li ngbNavItem="Profilbild">
			<a ngbNavLink>Profilbild</a>
			<ng-template ngbNavContent>
				<bp-grubenbild [bp]="bp"></bp-grubenbild>
			</ng-template>
		</li>
		<li ngbNavItem="Vegetation">
			<a ngbNavLink>Vegetation</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-vegetation [bp]="bp"></bp-bohrpunkt-vegetation>
			</ng-template>
		</li>
	}
	@else if (istPunktartMitKurzprotokoll(bp.type)) {
		<li ngbNavItem="Kurzprotokoll">
			<a ngbNavLink>Kurzprotokoll</a>
			<ng-template ngbNavContent>
				<bp-bohrpunkt-kurzprotokoll [bp]="bp"></bp-bohrpunkt-kurzprotokoll>
			</ng-template>
		</li>
	}
	<li ngbNavItem="Karte" (shown)="onDisplayMap()">
		<a ngbNavLink>Karte</a>
		<ng-template ngbNavContent>
			<bp-bohrpunkt-map *ngIf="displayMap" [bp]="bp" [bps]="bps" [pointsFilter]="pointsFilter" [mapStatus]="mapStatus" (pointDeleted)="onPointDeleted()"></bp-bohrpunkt-map>
		</ng-template>
	</li>
	<li ngbNavItem="Hinweise">
		<a ngbNavLink>Hinweise</a>
		<ng-template ngbNavContent>
			<bp-bohrpunkt-plausi [bp]="bp"></bp-bohrpunkt-plausi>
		</ng-template>
	</li>
</ul>
@if (canFreigeben) {
	<button type="button" class="btn btn-sm btn-success ms-2"
		title="Diesen Altpunkt in dieses Projekt übernehmen — Workflow wird zurückgesetzt; falls der Punkt zu einem anderen Projekt gehört, wird er dort entzogen (Manager)"
		(click)="onFreigeben()">
		<i class="bi bi-arrow-repeat"></i><span class="d-none d-lg-inline ms-1">In dieses Projekt übernehmen und zur Bearbeitung freigeben</span>
	</button>
}<!-- Protokoll-Info -->
<span class="protocol-info ms-auto me-3">
	<img *ngIf="!istPunktartOhneSymbol(bp.type)" [src]="punktartSvgUrl(bp.type)" alt="" class="protocol-type-icon">
	<span *ngIf="istPunktartOhneSymbol(bp.type)" class="protocol-type-label" title="Punktart ohne Symbol" [style.color]="punktartOhneSymbolColor(bp.type)">[{{ punktartOhneSymbolLabel(bp.type) }}]</span>
	<span class="protocol-nummer">{{ bp.header ? bp.header.nummer : '–' }}</span>
	<span class="protocol-separator">|</span>
	<span class="protocol-detail">{{ (bp.header && bp.header.aufnahme ? bp.header.aufnahme.kartierer : '–') | maskForGuest }}</span>
	<span class="protocol-separator">|</span>
	<span class="protocol-detail">{{ (bp.header && bp.header.aufnahme ? dateString(bp.header.aufnahme.datum) : '–') | maskForGuest }}</span>
	<!-- Workflow-Status ganz rechts als Farbpunkt (ohne Label); Verlauf/Übergänge im Hinweise-Tab. -->
	@if (currentBadge) {
		<span class="protocol-separator">|</span>
		<span class="protocol-status-dot {{currentBadge.bgClass}}" [title]="'Workflow-Status: ' + currentBadge.label"></span>
	} @else if (bp.workflow === undefined) {
		<span class="protocol-separator">|</span>
		<span class="protocol-status-dot bg-light border" title="Bestandsdaten ohne Workflow-Status"></span>
	}
</span>
</div>
<div [ngbNavOutlet]="nav"></div>
